import { CommonNS } from "../../../../../../Common/CommonNS.js";
export const toViewPortPoint = (self, { x, y }) => {
  const dummy_g_el = self._getDummyGElThrowable();
  const screen_ctm = dummy_g_el.getScreenCTM();
  if (screen_ctm == null) {
    throw new Error(`dummy_g 엘리먼트의 ScreenCTM 을 구할 수 없습니다.`);
  }
  const screen_ctm_inverse = screen_ctm.inverse();
  return CommonNS.UtilNS.createSVGPoint(self._svg_el)([x, y]).matrixTransform(
    screen_ctm_inverse
  );
};
